// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__4zmlP","links":"Contact_links__jdYkD","link":"Contact_link__aB+2C"};